import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '@app/shared';
import {NortificationComponent} from '@entities/nortification/nortification.component';
import {RouterModule, Routes} from '@angular/router';
import {Nortification} from '@entities/nortification/nortification.route';

@NgModule({
  declarations: [NortificationComponent],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(Nortification as Routes),
  ],
})
export class NortificationModule {}
